if (!customElements.get('athilco-mega-menu')) {
  customElements.define('athilco-mega-menu', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.items = Array.from(this.querySelectorAll('.athilco-nav__details'));
      const hover = matchMedia('(hover: hover) and (pointer: fine) and (min-width: 1141px)');
      this.close = (except = null) => this.items.forEach(item => { if (item !== except) item.open = false; });
      this.items.forEach(item => {
        const summary = item.querySelector('summary');
        summary.setAttribute('aria-expanded', String(item.open));
        item.addEventListener('toggle', () => {
          summary.setAttribute('aria-expanded', String(item.open));
          if (item.open) {
            this.close(item);
            this.style.setProperty('--athilco-menu-top', `${item.querySelector('.athilco-nav__panel').getBoundingClientRect().top}px`);
          }
        }, {signal});
        item.addEventListener('pointerenter', () => {
          if (!hover.matches) return;
          clearTimeout(this.leaveTimer);
          clearTimeout(this.enterTimer);
          this.enterTimer = setTimeout(() => { this.close(item); item.open = true; }, 120);
        }, {signal});
        item.addEventListener('pointerleave', () => {
          clearTimeout(this.enterTimer);
          this.leaveTimer = setTimeout(() => { item.open = false; }, 200);
        }, {signal});
        summary.addEventListener('click', () => { clearTimeout(this.enterTimer); clearTimeout(this.leaveTimer); }, {signal});
        item.addEventListener('focusout', () => {
          queueMicrotask(() => { if (!item.contains(document.activeElement)) item.open = false; });
        }, {signal});
      });
      this.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const current = this.items.find(item => item.open);
        if (!current) return;
        clearTimeout(this.enterTimer);
        clearTimeout(this.leaveTimer);
        this.close();
        current.querySelector('summary').focus();
        event.preventDefault();
        event.stopPropagation();
      }, {signal});
      document.addEventListener('pointerdown', event => {
        if (!this.contains(event.target)) this.close();
      }, {signal});
      window.addEventListener('resize', () => this.close(), {signal});
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      clearTimeout(this.enterTimer);
      clearTimeout(this.leaveTimer);
    }
  });
}
